import { generateTrackingId } from "./utilities";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Socket Connection ID

let socketConnectionId: string | undefined = undefined;

export function getSocketConnectionId(): string | undefined {
  return socketConnectionId;
}

export function updateSocketConnectionId(): void {
  // Requests a new Socket Connection ID, called when a WebSocket
  // connection is established
  socketConnectionId = generateTrackingId();
}

export function clearSocketConnectionId(): void {
  // Clears the Socket Connection ID, called when needed for cleanup
  socketConnectionId = undefined;
}
